<template>
  <div>
    <div class="pro-business" v-show="bagImg">
      <div class="pro-business-bg" ref="canvasImg">
        <img :src="bgImg" alt />
        <van-overlay :show="showOverlay" @click="showOverlay = false">
          <div class="wrapper" @click.stop>
            <div class="wra-userInfo">
              <div>{{username}}</div>
              <div>{{phone}}</div>
            </div>
            <div class="qr-img">
              <img :src="Simg" alt />
            </div>
          </div>
        </van-overlay>
      </div>
    </div>
    <div class="bottom-show-img" v-show="!bagImg">
      <img :src="imgUrl" alt class="cv-img" />
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import html2canvas from "html2canvas"
export default {
  data() {
    return {
      bgImg: null,
      Qimg: "",
      Simg: '',
      imgUrl: '',
      showOverlay: true,
      bagImg:true,
      username:'',
      phone:''
    };
  },
  mounted() {
    this.bgImg = localStorage.getItem("img");
    this.img = localStorage.getItem("img");
    this.Qimg = localStorage.getItem("Qimg");
    this.Simg = localStorage.getItem("Simg");
    this.phone=localStorage.getItem("showPhone");
    this.username=localStorage.getItem('showName')
    setTimeout(() => {
      this.downloads()
    }, 500);
  },
  methods: {
    downloads() {
      let that = this;
      Toast.loading({
        message: '加载中...',
        forbidClick: true, // 禁止背景点击
        duration: 0 // 持续展示
      })
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      var opts = {
        allowTaint: true,
        useCORS: true, // 【重要】开启跨域配置
        scrollY: 0, // 纵向偏移量 写死0 可以避免滚动造成偶尔偏移的现象
        scrollX: 0,
        height: that.$refs.canvasImg.offsetHeight - 8,
        width: that.$refs.canvasImg.offsetWidth,
        scale: 8,
        dpi: window.devicePixelRatio * 4,
        // backgroundColor: 'null',
      };
      setTimeout(() => {
        html2canvas(that.$refs.canvasImg, opts).then(res => {
          let dataURL = res.toDataURL("image/jpeg");
          that.imgUrl = dataURL;
          if (that.imgUrl) {
            Toast.clear()
            that.bagImg=false
            document.title="长按图片下载"
          }
        });
      }, 500);
    }
  }
};
</script>
<style lang="less" scoped>
.pro-business {
  .pro-business-bg {
    width: 335px;
    position: relative;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 100%;
    }
  }
  .pro-business-but {
    width: 272.5px;
    height: 42px;
    background: url("./img/product_bg3.png") no-repeat 100%;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 14px;
    color: #fff;
    .business-but {
      width: 50%;
      text-align: center;
    }
    .business-but-bor {
      border-right: 1px solid #ededed;
    }
  }
}
.van-overlay {
  position: absolute;
  width: 95%;
  height: 80px;
  top: auto;
  left: 50%;
  bottom: 15px;
  transform: translateX(-50%);
  border-radius: 10px;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.4);
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 100%;
  }
  .wra-userInfo {
    font-size: 20px;
    color: #fff;
    line-height: 1.4;
  }
  .qr-img {
    width: 70px;
    height: 70px;
    position: relative;
  }
}
.bottom-show-img {
  width: 355px;
  margin: auto;
  padding-top: 10px;
  img{
    width: 100%;
  }
}
</style>